module.exports = __webpack_public_path__ + "img/certification.c2ab0a25.png";